/* eslint-disable santa/no-module-state */
define([
    'santa-components',
    'lodash',
    'componentsCore',
    'components',
    'skins',
    'loginButton/skins/skins.json'
], function (santaComponents, _, componentsCore, components, skinsPackage, skinsJson) {
    'use strict';

    function onBtnClick(language) {
        let action;
        if (this.props.isLoggedIn) {
            this.props.logout(language);
            action = 'logout';
        } else {
            this.props.showAuthenticationDialog({
                language,
                appId: 3
            });
            action = 'login/signup';
        }
        this.props.reportSiteMembersBi('SITE_MEMBER_OPEN_LOGIN_OR_SIGNUP_DIALOGS', {action});
    }

    /**
     * @class components.loginButton
     * @extends {core.skinBasedComp}
     */
    const loginButton = {
        displayName: 'LoginButton',
        mixins: [componentsCore.mixins.skinBasedComp],

        propTypes: {
            compData: santaComponents.santaTypesDefinitions.Component.compData,
            style: santaComponents.santaTypesDefinitions.Component.style.isRequired,
            isLoggedIn: santaComponents.santaTypesDefinitions.SiteMembersSantaTypes.isLoggedIn.isRequired,
            logout: santaComponents.santaTypesDefinitions.SiteMembersSantaTypes.logout.isRequired,
            showAuthenticationDialog: santaComponents.santaTypesDefinitions.SiteMembersSantaTypes.showAuthenticationDialog.isRequired,
            reportSiteMembersBi: santaComponents.santaTypesDefinitions.SiteMembersSantaTypes.reportSiteMembersBi.isRequired,
            isReadyToShow: santaComponents.santaTypesDefinitions.LoginButton.isReadyToShow.isRequired,
            actionTitle: santaComponents.santaTypesDefinitions.LoginButton.actionTitle.isRequired,
            memberTitle: santaComponents.santaTypesDefinitions.LoginButton.memberTitle.isRequired
        },

        statics: {
            compSpecificIsDomOnlyOverride() {
                return false;
            }
        },

        getSkinProperties() {
            const language = this.props.compData ? this.props.compData.language : 'en';

            return {
                '': {
                    style: {
                        minHeight: this.props.style.height,
                        height: '', //fit to content
                        visibility: !this.props.isReadyToShow ? 'hidden' : null
                    }
                },
                'actionTitle': {
                    style: {width: this.props.style.width},
                    children: this.props.actionTitle,
                    onClick: onBtnClick.bind(this, language)
                },
                'memberTitle': {
                    style: {
                        width: this.props.style.width,
                        display: this.props.isLoggedIn ? null : 'none'
                    },
                    children: this.props.memberTitle
                }
            };
        }
    };

    componentsCore.compRegistrar.register('wysiwyg.viewer.components.LoginButton', loginButton);
    components.translationRequirementsChecker.registerCommonLanguageRequirement(
        'wysiwyg.viewer.components.LoginButton',
        (siteData, compInfo) => _.get(compInfo, ['data', 'language']));
    skinsPackage.skinsMap.addBatch(skinsJson);

    return loginButton;
});
